export class GeocodeCommand {
    lat: number;
    lon: number;
    source: string;
    libraries: string;
    region: string;
    language: string;
    constructor(
        lat: number,
        lon: number,
        source: string,
        libraries: string,
        region: string,
        language: string) {
        this.lat = lat;
        this.lon = lon;
        this.source = source;
        this.libraries = libraries;
        this.region = region;
        this.language = language;
    }
}
